import { render, staticRenderFns } from "./RoadUserAccidentEdit.vue?vue&type=template&id=7396d0ac"
import script from "./RoadUserAccidentEdit.vue?vue&type=script&lang=js"
export * from "./RoadUserAccidentEdit.vue?vue&type=script&lang=js"
import style0 from "./RoadUserAccidentEdit.vue?vue&type=style&index=0&id=7396d0ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports